/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import MainLayout from 'components/layouts/main'
import { notifySuccess, notifyError } from 'components/commons/toast'

import { ChatList } from 'features'

import { ChatReportsSelector, ChatReportsTypes } from 'store'

import { getChatReportedData, setHiddenMessage } from 'services'

import { ToastContainer } from 'react-toastify'
import { responseMessage } from 'constant'

const ChatReportsPage = () => {

  const {
    chats = [],
    limit,
    isRequesting,
    hasDataToLoad,
    orderRef,
    order,
  } = useSelector(ChatReportsSelector)

  const dispatch = useDispatch();

  useEffect(() => {
    getChats({
      displayLoader: true,
    });
  }, [])

  const getChats = ({ displayLoader = true }) => {
    if (isRequesting || !hasDataToLoad) {
      return false
    }

    dispatch({
      type: ChatReportsTypes.GET_CHAT_REPORTS_DATA,
      payload: { loading: displayLoader },
    })

    setTimeout(() => {
      getChatReportedData({ limit, order, orderRef }).then((payload) => {
        dispatch({
          type: ChatReportsTypes.SET_CHAT_REPORTS_DATA,
          payload,
        })
      })
    }, 1250)
  }

  const onHiddenMessage = async (params: any) => {
    await setHiddenMessage(params)
      .then((payload: any) => {
        const message = params.hidden
          ? responseMessage.successHide
          : responseMessage.successUnhide

        notifySuccess(message)

        dispatch({
          type: ChatReportsTypes.UPDATE_CHAT_REPORTS_DATA,
          payload,
        })
      })
      .catch((error) => {
        console.log(error)
        const message = params.hidden
          ? responseMessage.errorHide
          : responseMessage.errorUnhide
        notifyError(message)
      })
  }

  return (
    <React.Fragment>
      <MainLayout style={{ backgroundColor: '#FFFFFF' }}>
        <div style={{ backgroundColor: '#FFFFFF' }}>
          <h1 className='font-bold text-4xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
            Reported Messages
          </h1>
        </div>

        <ToastContainer limit={1} autoClose={3000} />

        <ChatList
          {...{
            chats,
            isRequesting,
            hasDataToLoad,
            onHiddenMessage
          }}
          onLoadMore={getChats}
        />
      </MainLayout>
    </React.Fragment>
  );
};

export default ChatReportsPage;